var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 658,
    viewBox: "0 0 242 658",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-32.6547 299.479C-115.786 323.471 -175.681 393.816 -174.373 476.511C-172.79 576.851 -79.8268 658.013 32.2114 656.99C144.194 655.985 234.635 574.377 234.635 473.84C234.635 429.335 218.727 387.105 187.426 356.797C103.798 275.783 -165.536 48.8364 -165.536 48.8364C-185.531 31.3904 -171.74 0.999981 -143.809 0.999982L242 0.999986",
    stroke: "url(#paint0_linear_249_76)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_76",
    x1: 50.229,
    y1: 0.999981,
    x2: 55.1237,
    y2: 657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BA6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftVector);
export default __webpack_public_path__ + "static/media/leftVector.c308aa961f1b4d02ede6bd1c24e92905.svg";
export { ForwardRef as ReactComponent };